const trueBlankDayTypeRequest = {
    dayTypeCode: '',
    fromDate:'',
    toDate: '',
    fromTime:'',
    toTime: '',
    status: 'U',
    myComment: '',
    statusComment: '',
  };
  
  export default trueBlankDayTypeRequest;